<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getUserLogins, getUser, unlockUser } from '@/services/serviceUser';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'UserLogins',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,MyPagination
		,MyCountRecords
		,Alert
	},
	props: {'userId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["userId","changeRecord"],
	data() {
		return {
			prefix:'',
		
			metaData: [],
			
			menuItems: [],
			isLoading:true,
							
			totalCount:0,
            dataList:[],

			user:[],
			
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
					
			filterExtended:false,
			showFilter:false
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.isLoading=true

			getUserLogins({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords, userId:this.userId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});

			getUser({userId:this.userId}).then(response => {
				if(!response.statusText){
					this.user = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},
		
		onClose:function(){
			if(this.userId!='null'){
				unlockUser({userId:this.userId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		}
		
	},
	
	watch: {
		userId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-dialog-scrollable modal-fullscreen">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.User') }} - {{ $t('msgCore.loginData') }} <b><span>{{ user.name }} {{ user.surname }}</span></b></h6>
				</div>
		
				<div v-if="metaData.modulAccess && auth.usersShowLoginData" class="modal-body">
					
					<div class="row">
						<div class="col-12">
								
							<!-- filters basic -->
							
							<!-- filters extended -->
							
						</div>
					</div>
					
					<!-- zakladny zoznam -->
					<div v-if="totalCount>0">
					
						<div class="row">
							<div class="col-12">
			
								<div class="table-responsive">
									<table class="table table-hover table-sm">
									
										<thead>
											<tr>
												
												<th>{{$t('msgCore.State')}}</th>
											
												<th>{{$t('msgCore.Created')}}</th>
											
												<th>{{$t('msgCore.SignedIn')}}</th>
												
												<th>{{$t('msgCore.SignedOut')}}</th>
												
												<th>{{$t('msgCore.Modified')}}</th>
												
												<th>{{$t('msgCore.IPaddress')}}</th>
												
												<th>{{$t('msgCore.lastActivity')}}</th>
												
												<th>{{$t('msgCore.id')}}</th>
												
											</tr>
										</thead>
										
										
										<tr v-for="(basicObj) in dataList" :key="basicObj" >
																					
											<td><span :class="basicObj.state_name_color">{{ $t('msgCore.'+basicObj.state_name) }}</span></td>
											
											<td>{{ basicObj.createdView }}</td>
											
											<td>{{ basicObj.signed_inView }}</td>
											
											<td>{{ basicObj.signed_outView }}</td>
											
											<td>
												<div v-if="basicObj.editor" class="personCircle v-center" v-bind:style="{background:basicObj.editorColor}" v-bind:title="basicObj.editor+', '+basicObj.modifiedView">{{ basicObj.editorNameLetter+''+basicObj.editorSurnameLetter }}</div>
											</td>
											
											<td>{{ basicObj.ipaddress }}</td>
											
											<td>{{ basicObj.lastActivityView }}</td>
											
											<td>{{ basicObj.id }}</td>
											
										</tr>
										
									</table>	
								</div>		
							
							</div>
						</div>
							
						<div class="row row-pagination">
							<div class="col-6 col-md-3 col-lg-2">
								<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
							</div>
							
							<div class="col-6 col-md-3 col-lg-2 box-flex">
								<span>Počet: {{totalCount}} </span>
							</div>
							
							<div class="col-12 col-md-6 col-lg-8">	
								<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
							</div>
						</div>
						
					</div>	
					
					<div v-else class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
						</div>							
					</div>

				</div>
				
				<div v-else class="modal-body">
					<div class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.accessDenied')" />
						</div>
					</div>
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>
</div>
</template>


